// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentTableWrapper__N77no {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 390px);
  overflow: auto;
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
}
.equipmentTableWrapper__N77no::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.equipmentTableWrapper__N77no::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.equipmentTableWrapper__N77no::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.equipmentTableWrapper__N77no::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 1024px) {
  .equipmentTableWrapper__N77no {
    max-height: calc(100vh - 350px);
  }
}

.ellipsisTextOneLine__FsICp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.ellipsisTextTwoLines__v7jRT {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.ellipsisTextThreeLines__WjF5o {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.equipmentTable__kOyDb {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.equipmentTable__kOyDb th {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}
@media (max-width: 1280px) {
  .equipmentTable__kOyDb th {
    padding: 10px 10px;
    font-size: 10px;
  }
}
@media (max-width: 900px) {
  .equipmentTable__kOyDb th {
    padding: 10px 8px;
    font-size: 9px;
  }
}
.equipmentTable__kOyDb td {
  padding: 7px 15px;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  white-space: normal;
}
@media (max-width: 1280px) {
  .equipmentTable__kOyDb td {
    padding: 7px 10px;
    font-size: 12px;
  }
}
@media (max-width: 1024px) {
  .equipmentTable__kOyDb td {
    font-size: 11px;
  }
}
@media (max-width: 900px) {
  .equipmentTable__kOyDb td {
    padding: 7px 8px;
    font-size: 10px;
  }
}

.equipmentTableBodyRow__Ae6cT:hover {
  background: var(--tables-primary-row-surface-hover);
}

.selectedRow__AIR6e {
  font-weight: 500;
}

.equipmentTableSortIcon__TI6QJ {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.equipmentTableSortIcon__TI6QJ path {
  fill: var(--tables-title-icon);
}

.activeSort__vTC3w path {
  fill: var(--tables-primary-row-icon);
}

.facilityName__qPKUZ {
  margin-top: 5px;
  color: var(--tables-primary-row-text-additional);
}

@media (max-width: 1024px) {
  .locationColumn__XWUkT {
    max-width: 80px;
  }
}
@media (max-width: 900px) {
  .locationColumn__XWUkT {
    max-width: 70px;
  }
}

@media (max-width: 1024px) {
  .assetCodeColumn__s82TE {
    max-width: 90px;
  }
}
@media (max-width: 900px) {
  .assetCodeColumn__s82TE {
    max-width: 80px;
  }
}

@media (max-width: 1024px) {
  .equipmentTypeColumn__gXO0c {
    max-width: 70px;
  }
}
@media (max-width: 900px) {
  .equipmentTypeColumn__gXO0c {
    max-width: 60px;
  }
}

.equipmentStatusActive__aYccC {
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding: 4px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid;
  width: min-content;
  border-color: var(--labels-outline-stroke-text-success);
  color: var(--labels-outline-stroke-text-success);
}
@media (max-width: 1024px) {
  .equipmentStatusActive__aYccC {
    font-size: 10px;
    padding: 3px;
  }
}

.equipmentStatusInactive__ttJis {
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding: 4px 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  border: 1px solid;
  width: min-content;
  color: var(--labels-filled-surface-critical);
  border-color: var(--labels-filled-surface-critical);
}
@media (max-width: 1024px) {
  .equipmentStatusInactive__ttJis {
    font-size: 10px;
    padding: 3px;
  }
}

.actionsColumn__XFQ0V {
  min-width: 30px;
  max-width: 30px;
}

.actionsIconContainer__kkz0m {
  margin-left: auto;
  -webkit-user-select: none;
          user-select: none;
  text-align: center;
  cursor: pointer;
  outline: none;
}

.equipmentTableFooter__E0jLm {
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 35px;
}
@media (max-width: 1024px) {
  .equipmentTableFooter__E0jLm {
    gap: 10px;
    margin-top: 15px;
  }
}

.equipmentTableFooterLeft__cokHq {
  font-style: normal;
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--inputs-default-text);
}
@media (max-width: 1024px) {
  .equipmentTableFooterLeft__cokHq {
    font-size: 10px;
    line-height: 12px;
  }
}
@media (max-width: 800px) {
  .equipmentTableFooterLeft__cokHq {
    font-size: 9px;
  }
}

.equipmentTableFooterRight__QtZhj {
  display: flex;
  align-items: center;
  gap: 20px;
}
@media (max-width: 1366px) {
  .equipmentTableFooterRight__QtZhj button {
    width: unset;
  }
}
@media (max-width: 1024px) {
  .equipmentTableFooterRight__QtZhj {
    gap: 10px;
  }
  .equipmentTableFooterRight__QtZhj button {
    font-size: 10px;
    line-height: 12px;
  }
}

.selectedRows__VLfn9 {
  display: flex;
  align-items: center;
  gap: 15px;
}
@media (max-width: 1024px) {
  .selectedRows__VLfn9 {
    gap: 10px;
  }
}

.selectedRowsInfo__N80Yc {
  text-transform: uppercase;
  color: var(--tables-primary-row-text-main);
  font-size: 10px;
  font-weight: 500;
}
@media (max-width: 1024px) {
  .selectedRowsInfo__N80Yc {
    font-size: 9px;
  }
}
@media (max-width: 800px) {
  .selectedRowsInfo__N80Yc {
    font-size: 8px;
  }
}

.skeletonRow__lZt_I td {
  padding-top: 16px;
  padding-bottom: 15px;
}
.skeletonRow__lZt_I td:last-child .skeletonText__fBX4U {
  display: none;
}

.skeletonText__fBX4U {
  height: 24px;
}

.skeletonCheckbox__LL8DW {
  height: 0;
}

.sortColumnWrapper__Z7354 {
  display: flex;
  align-items: center;
}
.sortColumnWrapper__Z7354 .infoIcon__eilFW {
  outline: none;
  margin-left: 5px;
}

.smallWidthShow__FhL16 {
  display: none;
}
@media (max-width: 900px) {
  .smallWidthShow__FhL16 {
    display: inline-block;
  }
}

.bigWidthShow__c4j8n {
  display: inline-block;
}
@media (max-width: 900px) {
  .bigWidthShow__c4j8n {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageEquipment/components/TableEquipments/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,qDAAA;EACA,mCAAA;AAzEF;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA4DE;EAVF;IAWI,+BAAA;EAzDF;AACF;;AA4DA;EAxCE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAqCA,qBAAA;EACA,aAAA;AApDF;;AAuDA;EA9CE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EA2CA,qBAAA;EACA,aAAA;AA/CF;;AAkDA;EApDE,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EAiDA,qBAAA;EACA,aAAA;AA1CF;;AA6CA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AA1CF;AA4CE;EACE,kBAAA;EACA,gBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1CJ;AA4CI;EAhBF;IAiBI,kBAAA;IACA,eAAA;EAzCJ;AACF;AA2CI;EArBF;IAsBI,iBAAA;IACA,cAAA;EAxCJ;AACF;AA2CE;EACE,iBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yDAAA;EACA,mBAAA;AAzCJ;AA2CI;EAVF;IAWI,iBAAA;IACA,eAAA;EAxCJ;AACF;AA0CI;EAfF;IAgBI,eAAA;EAvCJ;AACF;AAyCI;EAnBF;IAoBI,gBAAA;IACA,eAAA;EAtCJ;AACF;;AA2CE;EACE,mDAAA;AAxCJ;;AA4CA;EACE,gBAAA;AAzCF;;AA4CA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAzCF;AA2CE;EACE,8BAAA;AAzCJ;;AA8CE;EACE,oCAAA;AA3CJ;;AA+CA;EACE,eAAA;EACA,gDAAA;AA5CF;;AAgDE;EADF;IAEI,eAAA;EA5CF;AACF;AA8CE;EALF;IAMI,eAAA;EA3CF;AACF;;AA+CE;EADF;IAEI,eAAA;EA3CF;AACF;AA6CE;EALF;IAMI,eAAA;EA1CF;AACF;;AA8CE;EADF;IAEI,eAAA;EA1CF;AACF;AA4CE;EALF;IAMI,eAAA;EAzCF;AACF;;AA+DA;EAlBE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EAUA,uDAAA;EACA,gDAAA;AAlDF;AAyCE;EAMF;IALI,eAAA;IACA,YAAA;EAtCF;AACF;;AA+CA;EAxBE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EAgBA,4CAAA;EACA,mDAAA;AAlCF;AAmBE;EAYF;IAXI,eAAA;IACA,YAAA;EAhBF;AACF;;AA+BA;EACE,eAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AA5BF;AA8BE;EAPF;IAQI,SAAA;IACA,gBAAA;EA3BF;AACF;;AA8BA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;AA3BF;AA6BE;EAPF;IAQI,eAAA;IACA,iBAAA;EA1BF;AACF;AA4BE;EAZF;IAaI,cAAA;EAzBF;AACF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAzBF;AA2BE;EACE;IACE,YAAA;EAzBJ;AACF;AA4BE;EAXF;IAYI,SAAA;EAzBF;EA2BE;IACE,eAAA;IACA,iBAAA;EAzBJ;AACF;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA1BF;AA4BE;EALF;IAMI,SAAA;EAzBF;AACF;;AA4BA;EACE,yBAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;AAzBF;AA2BE;EANF;IAOI,cAAA;EAxBF;AACF;AA0BE;EAVF;IAWI,cAAA;EAvBF;AACF;;AA2BE;EACE,iBAAA;EACA,oBAAA;AAxBJ;AA0BI;EACE,aAAA;AAxBN;;AA6BA;EACE,YAAA;AA1BF;;AA6BA;EACE,SAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,aAAA;EACA,gBAAA;AA1BJ;;AA8BA;EACE,aAAA;AA3BF;AA4BE;EAFF;IAGI,qBAAA;EAzBF;AACF;;AA4BA;EACE,qBAAA;AAzBF;AA0BE;EAFF;IAGI,aAAA;EAvBF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 390px);\n  overflow: auto;\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n\n  @include scrollBar;\n\n  @media (max-width: 1024px) {\n    max-height: calc(100vh - 350px);\n  }\n}\n\n.ellipsisTextOneLine {\n  @include ellipsis-text;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n}\n\n.ellipsisTextTwoLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n}\n\n.ellipsisTextThreeLines {\n  @include ellipsis-text;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.equipmentTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n\n  th {\n    padding: 16px 15px;\n    text-align: left;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    color: var(--tables-title-text);\n    font-size: 11px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    text-transform: uppercase;\n\n    @media (max-width: 1280px) {\n      padding: 10px 10px;\n      font-size: 10px;\n    }\n\n    @media (max-width: 900px) {\n      padding: 10px 8px;\n      font-size: 9px;\n    }\n  }\n\n  td {\n    padding: 7px 15px;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n    border-bottom: 1px solid var(--tables-primary-row-stroke);\n    white-space: normal;\n\n    @media (max-width: 1280px) {\n      padding: 7px 10px;\n      font-size: 12px;\n    }\n\n    @media (max-width: 1024px) {\n      font-size: 11px;\n    }\n\n    @media (max-width: 900px) {\n      padding: 7px 8px;\n      font-size: 10px;\n    }\n  }\n}\n\n.equipmentTableBodyRow {\n  &:hover {\n    background: var(--tables-primary-row-surface-hover);\n  }\n}\n\n.selectedRow {\n  font-weight: 500;\n}\n\n.equipmentTableSortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.facilityName {\n  margin-top: 5px;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.locationColumn {\n  @media (max-width: 1024px) {\n    max-width: 80px;\n  }\n\n  @media (max-width: 900px) {\n    max-width: 70px;\n  }\n}\n\n.assetCodeColumn {\n  @media (max-width: 1024px) {\n    max-width: 90px;\n  }\n\n  @media (max-width: 900px) {\n    max-width: 80px;\n  }\n}\n\n.equipmentTypeColumn {\n  @media (max-width: 1024px) {\n    max-width: 70px;\n  }\n\n  @media (max-width: 900px) {\n    max-width: 60px;\n  }\n}\n\n@mixin equipmentStatusItem {\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  padding: 4px 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  border: 1px solid;\n  width: min-content;\n\n  @media (max-width: 1024px) {\n    font-size: 10px;\n    padding: 3px;\n  }\n}\n\n.equipmentStatusActive {\n  @include equipmentStatusItem;\n  border-color: var(--labels-outline-stroke-text-success);\n  color: var(--labels-outline-stroke-text-success);\n}\n\n.equipmentStatusInactive {\n  @include equipmentStatusItem;\n  color: var(--labels-filled-surface-critical);\n  border-color: var(--labels-filled-surface-critical);\n}\n\n.actionsColumn {\n  min-width: 30px;\n  max-width: 30px;\n}\n\n.actionsIconContainer {\n  margin-left: auto;\n  user-select: none;\n  text-align: center;\n  cursor: pointer;\n  outline: none;\n}\n\n.equipmentTableFooter {\n  margin-top: 25px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 35px;\n\n  @media (max-width: 1024px) {\n    gap: 10px;\n    margin-top: 15px;\n  }\n}\n\n.equipmentTableFooterLeft {\n  font-style: normal;\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--inputs-default-text);\n\n  @media (max-width: 1024px) {\n    font-size: 10px;\n    line-height: 12px;\n  }\n\n  @media (max-width: 800px) {\n    font-size: 9px;\n  }\n}\n\n.equipmentTableFooterRight {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n\n  @media (max-width: 1366px) {\n    button {\n      width: unset;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    gap: 10px;\n\n    button {\n      font-size: 10px;\n      line-height: 12px;\n    }\n  }\n}\n\n.selectedRows {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n\n  @media (max-width: 1024px) {\n    gap: 10px;\n  }\n}\n\n.selectedRowsInfo {\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-main);\n  font-size: 10px;\n  font-weight: 500;\n\n  @media (max-width: 1024px) {\n    font-size: 9px;\n  }\n\n  @media (max-width: 800px) {\n    font-size: 8px;\n  }\n}\n\n.skeletonRow {\n  td {\n    padding-top: 16px;\n    padding-bottom: 15px;\n\n    &:last-child .skeletonText {\n      display: none;\n    }\n  }\n}\n\n.skeletonText {\n  height: 24px;\n}\n\n.skeletonCheckbox {\n  height: 0;\n}\n\n.sortColumnWrapper {\n  display: flex;\n  align-items: center;\n\n  .infoIcon {\n    outline: none;\n    margin-left: 5px;\n  }\n}\n\n.smallWidthShow {\n  display: none;\n  @media (max-width: 900px) {\n    display: inline-block;\n  }\n}\n\n.bigWidthShow {\n  display: inline-block;\n  @media (max-width: 900px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentTableWrapper": `equipmentTableWrapper__N77no`,
	"ellipsisTextOneLine": `ellipsisTextOneLine__FsICp`,
	"ellipsisTextTwoLines": `ellipsisTextTwoLines__v7jRT`,
	"ellipsisTextThreeLines": `ellipsisTextThreeLines__WjF5o`,
	"equipmentTable": `equipmentTable__kOyDb`,
	"equipmentTableBodyRow": `equipmentTableBodyRow__Ae6cT`,
	"selectedRow": `selectedRow__AIR6e`,
	"equipmentTableSortIcon": `equipmentTableSortIcon__TI6QJ`,
	"activeSort": `activeSort__vTC3w`,
	"facilityName": `facilityName__qPKUZ`,
	"locationColumn": `locationColumn__XWUkT`,
	"assetCodeColumn": `assetCodeColumn__s82TE`,
	"equipmentTypeColumn": `equipmentTypeColumn__gXO0c`,
	"equipmentStatusActive": `equipmentStatusActive__aYccC`,
	"equipmentStatusInactive": `equipmentStatusInactive__ttJis`,
	"actionsColumn": `actionsColumn__XFQ0V`,
	"actionsIconContainer": `actionsIconContainer__kkz0m`,
	"equipmentTableFooter": `equipmentTableFooter__E0jLm`,
	"equipmentTableFooterLeft": `equipmentTableFooterLeft__cokHq`,
	"equipmentTableFooterRight": `equipmentTableFooterRight__QtZhj`,
	"selectedRows": `selectedRows__VLfn9`,
	"selectedRowsInfo": `selectedRowsInfo__N80Yc`,
	"skeletonRow": `skeletonRow__lZt_I`,
	"skeletonText": `skeletonText__fBX4U`,
	"skeletonCheckbox": `skeletonCheckbox__LL8DW`,
	"sortColumnWrapper": `sortColumnWrapper__Z7354`,
	"infoIcon": `infoIcon__eilFW`,
	"smallWidthShow": `smallWidthShow__FhL16`,
	"bigWidthShow": `bigWidthShow__c4j8n`
};
module.exports = ___CSS_LOADER_EXPORT___;
